import React from "react";
import chapeau from "../../assets/img/icone_toque_rouge.png";
import Admission from "./Admission";
import commite from "../../assets/img/commute_1.jpeg";
import commite1 from "../../assets/img/cimmite_3.jpeg";
import commite2 from "../../assets/img/commite_2.jpeg";
import Titre from "../common/Titre";

export default function AdmissionList() {
  const admissions = [
    {
      id: 1,
      titre: "CURRICULUM CANADIEN",
      contenu:
        "Contenu expliquant comment obtenir une inscription dans une université ou un collège",
      nombre: "1",
      page: "/curriculum",
      img: commite,
    },
    {
      id: 2,
      titre: "PROGRAMME PREPA UNIVERSITAIRE",
      contenu:
        "Contenu expliquant la procédure d'obtention des équivalences de diplômes pour les étudiants étrangers.",
      nombre: "2",
      page: "/prepa-gd",
      img: commite1,
    },

    {
      id: 3,
      titre: "PROGRAMME HYBRIDE(DOUBLE DIPLOME)",
      contenu:
        "Contenu expliquant la procédure d'obtention des équivalences de diplômes pour les étudiants étrangers.",
      nombre: "2",
      page: "/prepa-hybride",
      img: commite2,
    },
  ];

  return (
    <>
      <div className=" edu_counter_main_section_wrapper parallax-bg-4 rounded-0 mb-5 d-none d-lg-block">
        <div className="row w-100 p-0 m-0 justify-content-start align-items-start">
          <div className="col-12 col-sm-6 col-md-3 text-left m-0 p-2 z-3 mx-auto">
            <h1
              className="custom-titre-h1 text-white fs-4"
              style={{ fontWeight: "bold" }}
            >
              Decouvrez nos programmes
            </h1>
          </div>

          {/* Masquer en dessous des écrans de taille md */}
          <div
            className="col-12 col-sm-9 col-md-9 z-3 p-2 m-0 "
            style={{ transform: "translateY(30%)" }}
          >
            <div className="row w-100 z-3 ">
              {admissions.length > 0 &&
                admissions.map((e) => <Admission item={e} key={e.id} />)}
            </div>
          </div>
        </div>
      </div>

      <div className=" d-block d-lg-none ">
        <Titre
          children={"Decouvrez nos programmes"}
          soustitre={"Restez informés de toutes les nouvelles actualités."}
        />
        <div className="row w-100 m-0 p-0  ">
          {admissions.length > 0 &&
            admissions.map((e) => <Admission item={e} key={e.id} />)}
        </div>
      </div>
    </>
  );
}
